import { Tabs, TabsContent, TabsList, TabsTrigger } from '@mesh.ai/rabbit';
import { NotificationSettingsIntent } from 'Deer/intent/Settings/Notification/NotificationSettingsIntent';
import { useQuery } from 'components/hooks/useQuery';
import { useHistory } from 'react-router-dom';
import Competencies from 'screens/admin/Competencies';
import { CompetencySettings } from 'screens/admin/Competencies/CompetencySettings/CompetencySettings';

const MODULE_SETTINGS_TABS = [
  {
    name: 'Notifications',
    queryParamId: 'notifications',
    Comp: NotificationSettingsIntent,
  },
  {
    name: 'Competency Library',
    queryParamId: 'competency_library',
    Comp: Competencies,
  },
  {
    name: 'Competency Settings',
    queryParamId: 'competency_settings',
    Comp: CompetencySettings,
  },
];

const NetchexMiscellaneousSettings = () => {
  const history = useHistory();
  const { activeTabId } = useQuery();

  const onTabChangeHandler = (newActiveTab: string) => {
    history.push({
      search: `?${new URLSearchParams({
        activeTabId: newActiveTab,
      }).toString()}`,
    });
  };

  if (!activeTabId) {
    onTabChangeHandler(MODULE_SETTINGS_TABS[0].queryParamId);
  }

  return (
    <>
      <Tabs variant="secondary" value={activeTabId as string} onValueChange={onTabChangeHandler} className="mt-1">
        <TabsList>
          {MODULE_SETTINGS_TABS.map(({ name, queryParamId }) => (
            <TabsTrigger key={queryParamId} value={queryParamId}>
              {name}
            </TabsTrigger>
          ))}
        </TabsList>

        {MODULE_SETTINGS_TABS.map(({ Comp, queryParamId }) => (
          <TabsContent key={queryParamId} value={queryParamId}>
            <Comp />
          </TabsContent>
        ))}
      </Tabs>
    </>
  );
};

export { NetchexMiscellaneousSettings };
